// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"c8e433ba","108":"952824b9","203":"8c6cd9e5","242":"1a815610","272":"cc4075f8","273":"66cb0531","279":"22b69e6a","325":"25fc0589","488":"2d583332","562":"7fc2f580","669":"843deec7","704":"588ac52c","858":"19f22841","872":"7e6dca4b","878":"2ff995ad","974":"60ae05a4"}[chunkId] + ".chunk.js";
};